<template>

  <Form
    :title="$t('Conversational Agent')"
    :creating="creating"
    :loading="loading">
    <p>Configure os agentes conversacionais da conta. Cada público tem seu próprio tom de voz e seus próprios fluxos.</p>

    <form
      id="conversational-agent-form"
      class="shurt-conatiner"
      v-on:submit.prevent="saveConversationalAgent(conversational_agent)">

      <component
        v-for="(audience, index) in audiences"
        :key="audience.key"
        :is="audience.component"
        :class="{'mt-5': index > 0}"
        :value="conversational_agent[audience.key]"
        :validate-errors="validateErrors"
        :error-prefix="`conversational_agent.${audience.key}`" />

    </form>
    <template slot="actions">
      <button
        :class="{'box-loading': loading}"
        type="submit"
        form="conversational-agent-form"
        class="btn btn-primary">
        {{ $t('Save') }}
        </button>
    </template>
  </Form>

</template>

<script>
import Form from '@/components/Form/Form'
import AccountConversationalAgentCandidate, {defaultCandidate, mergeCandidate} from './AccountConversationalAgentCandidate'

/*
AUDIENCES
publicos do agente conversacional
para adicionar um novo (ex: manager) crie o componente da secao,
exportando o default e o merge da sua estrutura, e registre aqui
*/
const AUDIENCES = [
  {
    key: 'candidate',
    component: 'AccountConversationalAgentCandidate',
    default: defaultCandidate,
    merge: mergeCandidate
  }
]

const defaultConversationalAgent = () => AUDIENCES.reduce((agent, audience) => {
  agent[audience.key] = audience.default()
  return agent
}, {})

export default {
  name: 'AccountConversationalAgent',
  components: {
    Form,
    AccountConversationalAgentCandidate
  },
  data () {
    return {
      creating: true,
      loading: false,
      audiences: AUDIENCES,
      conversational_agent: defaultConversationalAgent(),
      validateErrors: {}
    }
  },
  computed: {
    account () {
      return this.$store.getters.getAccount
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.$store
      .dispatch('getAccountConversationalAgent', this.account._id)
      .then(result => {
        this.conversational_agent = this.mergeDefaults(result.conversational_agent)
      })
      .catch((err) => {
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
      .finally(() => {
        this.creating = false
      })
    },
    /*
    saveConversationalAgent
    */
    saveConversationalAgent (data) {
      this.loading = true

      this.$store
      .dispatch('updateAccountConversationalAgent', {
        _id: this.account._id,
        conversational_agent: data
      })
      .then((result) => {
        this.conversational_agent = this.mergeDefaults(result.conversational_agent)
        this.loading = false
        this.validateErrors = {}
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    mergeDefaults
    garante a estrutura completa de cada publico mesmo quando a api retorna campos parciais
    */
    mergeDefaults (data) {
      const conversationalAgent = data || {}

      return AUDIENCES.reduce((agent, audience) => {
        agent[audience.key] = audience.merge(conversationalAgent[audience.key])
        return agent
      }, {...conversationalAgent})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Account/AccountConversationalAgent.vue